// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"loading_loading-wrapper__2jFD_","loading-content":"loading_loading-content__FChzi"};